import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';
import { ResizeDirection } from '../../../types/common/types';
import { SideMenuWidthValues } from '../../../ui/gzSideMenu/types';

const responseGridTemplate = document.createElement('template');

responseGridTemplate.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <gz-push-body-layout resizable="right">
    <div slot="push-body-sidenav-title">
      <gz-title id="edr-response-smart-views-title" fontsize="11" fontweight="600" />
    </div>

    <div slot="push-body-sidenav">
      <gz-generic-grid-smart-views class="hidden" />

      <div id="edr-response-smart-views-loader">
        <gz-loader rows="4"></gz-loader>
      </div>
    </div>

    <div class="push-body" slot="push-body-content">
      <div class="push-body--content">
        <div class="wrapper">
          <div class="content">
            <div class="grid">
              <gz-grid-view noEscapeSpaceInTitle />
            </div>
          </div>
        </div>
      </div>
    </div>
  </gz-push-body-layout>

  <gz-side-menu
    id="custom-rule-details"
    resizable="${ResizeDirection.LEFT}"
    menuWidth="${SideMenuWidthValues.MEDIUM}"
    closeOnClickOutside
  />
`;

export default responseGridTemplate;
